const SHOW_PAGE = 'SHOW_PAGE';
const HIDE_PAGE = 'HIDE_PAGE';

export function openPage(pageOptions) {
  return dispatch => {
    dispatch({
      type: SHOW_PAGE,
      pageType: pageOptions.pageType,
      pageProps: pageOptions.pageProps
    });
  };
}
export function hidePage() {
  return dispatch => {
    dispatch({
      type: HIDE_PAGE
    });
  };
}
const initialState = {
  pageType: null,
  pageProps: {}
};

const pageReducer = (state = initialState, action) => {
  switch (action.type) {
  case SHOW_PAGE: {
    return {
      pageType: action.pageType,
      pageProps: action.pageProps
    };
  }
  case HIDE_PAGE: {
    return initialState;
  }
  default: {
    return state;
  }
  }
};

export function isPageOpened(state) {
  return state.page.pageType != null;
}

export default pageReducer;



// WEBPACK FOOTER //
// ./src/reducers/pageReducer.js